import { useRef, useState } from 'react'

import { Button } from '@/components/ui/Button'
import { Textarea } from '@/components/ui/Input'

interface Props {
  busy: boolean
  onSubmit: (text: string) => void
  onStop: () => void
}

export function ChatComposer({ busy, onSubmit, onStop }: Props) {
  const [value, setValue] = useState('')
  const ref = useRef<HTMLTextAreaElement>(null)

  const submit = () => {
    if (!value.trim() || busy) return
    onSubmit(value)
    setValue('')
    ref.current?.focus()
  }

  return (
    <div className="border-t border-line bg-surface p-3">
      <Textarea
        ref={ref}
        value={value}
        rows={3}
        placeholder="描述要采购的设备、参数或预算，例如：查 800kVA 干式变压器，要 10kV、能效 1 级"
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault()
            submit()
          }
        }}
      />
      <div className="mt-2 flex items-center justify-between">
        <span className="text-[11px] text-muted">Enter 发送 · Shift + Enter 换行</span>
        <div className="flex gap-2">
          {busy && (
            <Button size="sm" onClick={onStop}>
              停止
            </Button>
          )}
          <Button size="sm" variant="primary" onClick={submit} disabled={!value.trim() || busy}>
            {busy ? '查询中' : '查询'}
          </Button>
        </div>
      </div>
    </div>
  )
}
